module.exports = __webpack_public_path__ + "media/images/help-w-badge-c70d93c846afc06a391ff2ad52cb6798.svg";